webpackJsonp([308],{

/***/ 1058:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerRelationshipForm_vue__ = __webpack_require__(2637);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ed0e2b5_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomerRelationshipForm_vue__ = __webpack_require__(3828);
function injectStyle (ssrContext) {
  __webpack_require__(3825)
}
var normalizeComponent = __webpack_require__(11)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5ed0e2b5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerRelationshipForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ed0e2b5_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_CustomerRelationshipForm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 2637:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CustomerRelationshipForm_js__ = __webpack_require__(3827);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__CustomerRelationshipForm_js__["a"]; });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/***/ }),

/***/ 3825:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(3826);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(991)("203be076", content, true, {});

/***/ }),

/***/ 3826:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(990)(true);
// imports


// module
exports.push([module.i, ".add-contact[data-v-5ed0e2b5]{float:right}.margin[data-v-5ed0e2b5]{margin:100px auto auto}.delete-button[data-v-5ed0e2b5]{float:right}.contact-title[data-v-5ed0e2b5]{margin:50px auto 20px}.contact-body[data-v-5ed0e2b5]{margin:20px auto}", "", {"version":3,"sources":["/workspace/src/views/customer/pages/CustomerRelationshipForm.vue"],"names":[],"mappings":"AACA,8BAA8B,WAAW,CACxC,AACD,yBAAyB,sBAA2B,CACnD,AACD,gCAAgC,WAAW,CAC1C,AACD,gCAAgC,qBAA0B,CACzD,AACD,+BAA+B,gBAAgB,CAC9C","file":"CustomerRelationshipForm.vue","sourcesContent":["\n.add-contact[data-v-5ed0e2b5]{float:right\n}\n.margin[data-v-5ed0e2b5]{margin:100px auto auto auto\n}\n.delete-button[data-v-5ed0e2b5]{float:right\n}\n.contact-title[data-v-5ed0e2b5]{margin:50px auto 20px auto\n}\n.contact-body[data-v-5ed0e2b5]{margin:20px auto\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 3827:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  data: function data() {
    return {
      inputWith: 12,
      formRules: {
        relationship_type: [{ required: true, message: '客户关系类型不能为空', trigger: 'blur' }],
        mail_post_time: [{ validator: this.pushtimeValidator, trigger: 'blur' }]
      },
      id: 0,
      form: {
        name: '',
        number: '',
        relationship_type: '',
        mail_post_time: '',
        contactors: [],
        buyers: [],
        mainContactors: [{
          name: '',
          job_title: '',
          email: '',
          phone: ''
        }]
      }
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Vuex.mapState({
    options: function options(state) {
      return state.customer.options;
    }
  })),
  watch: {},
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      return vm.onLoad();
    });
  },
  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    this.onReload();
    next();
  },
  created: function created() {},
  mounted: function mounted() {},

  methods: {
    onLoad: function onLoad() {
      if (this.$route.params.id) {
        this.setForm(this.id = this.$route.params.id);
      }
    },
    onReload: function onReload() {
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.$data, this.$options.data());
      this.onLoad();
    },
    setForm: function setForm(id) {
      var _this = this;

      request.page('getCustomerRelationshipDetail', { id: id }).then(function (_ref) {
        var data = _ref.data;

        if (data.mail_post_time === '0000-00-00 00:00:00') {
          data.mail_post_time = '';
        } else {
          data.mail_post_time = moment(data.mail_post_time).format('YYYY-MM-DD');
        }
        filter.setLoop(_this.form, data);
      });
    },
    onSubmit: function onSubmit() {
      var _this2 = this;

      this.$refs['form'].validate(function (valid) {
        if (valid && _this2.id) {
          if (!_this2.checkSubmit()) return;

          _this2.update(_this2.id);
        } else {
          _this2.$message.error('提交内容填写不正确！');
        }
      });
    },
    update: function update(id) {
      var _this3 = this;

      request.common('updateCustomerRelationshipData', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({ id: id }, this.form)).then(function (res) {
        _this3.$confirm(_this3.$route.meta.title + '成功, 是否前往列表页面？', '提示', { type: 'success' }).then(function () {
          _this3.$router.push({ name: '客户列表' });
        });
      });
    },
    onAddContactor: function onAddContactor() {
      var params = {
        name: '',
        email: '',
        phone: '',
        id: '',
        type: 1
      };
      this.form.contactors.push(params);
    },
    onAddBuyer: function onAddBuyer() {
      var params = {
        name: '',
        email: '',
        phone: '',
        id: '',
        type: 2
      };
      this.form.buyers.push(params);
    },
    onDelContactor: function onDelContactor(index) {
      this.form.contactors.splice(index, 1);
    },
    onDelBuyer: function onDelBuyer(index) {
      this.form.buyers.splice(index, 1);
    },


    // 验证潜在客户 推送时间
    pushtimeValidator: function pushtimeValidator(rule, value, callback) {
      if (!this.form.mail_post_time && this.form.relationship_type === '3') {
        callback(new Error('发送时间不能为空'));
      } else {
        callback();
      }
    },

    // 检查活动通用字段
    checkSubmit: function checkSubmit() {
      if (this.form.relationship_type !== '3') {
        delete this.form.mail_post_time;
      }
      if (this.form.contactors.length > 4) {
        this.$message.error('项目对接人不能超过5个');
        return false;
      }
      var isPass = this.checkMainContactors(this.form.mainContactors);
      if (!isPass) {
        return false;
      }

      if (this.form.buyers.length > 5) {
        this.$message.error('客户采购不能超过5个');
        return false;
      }
      for (var i = 0; i < this.form.contactors.length; i++) {
        var _isPass = this.checkContact(this.form.contactors[i].name, this.form.contactors[i].phone, this.form.contactors[i].email);
        if (!_isPass) {
          return false;
        }
      }
      for (var _i = 0; _i < this.form.buyers.length; _i++) {
        var _isPass2 = this.checkContact(this.form.buyers[_i].name, this.form.buyers[_i].phone, this.form.buyers[_i].email);
        if (!_isPass2) {
          return false;
        }
      }
      return true;
    },
    checkMainContactors: function checkMainContactors(mainContactors) {
      for (var i in mainContactors) {
        var one = mainContactors[i];
        if (!this.checkContact(one.name, one.phone, one.email)) {
          return false;
        }
      }
      return true;
    },
    checkContact: function checkContact(name, phone, email) {
      if (!name) {
        this.$message.error('客户联系人不能为空');
        return false;
      }
      if (!phone) {
        this.$message.error('联系方式不能为空');
        return false;
      }
      if (!/^[1]\d{10}$/.test(phone) || !phone.length === 11) {
        this.$message.error('联系方式不符合规范');
        return false;
      }
      if (!email) {
        this.$message.error('邮箱不能为空');
        return false;
      }
      if (!/^([.a-zA-Z0-9_-])+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(email)) {
        this.$message.error('邮箱格式不符合规范');
        return false;
      }
      return true;
    }
  }
});

/***/ }),

/***/ 3828:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"title",rawName:"v-title",value:(_vm.$route.meta.title),expression:"$route.meta.title"}]},[_c('div',{staticClass:"page-heading"},[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',{attrs:{"to":"/"}},[_vm._v("首页")]),_vm._v(" "),_c('el-breadcrumb-item',{attrs:{"to":"/customer"}},[_vm._v("客户管理")]),_vm._v(" "),_c('el-breadcrumb-item',[_vm._v(_vm._s(_vm.$route.meta.title))])],1)],1),_vm._v(" "),_c('layout-panel',[_c('span',{attrs:{"slot":"header"},slot:"header"},[_vm._v("表单")]),_vm._v(" "),_c('el-form',{ref:"form",attrs:{"model":_vm.form,"rules":_vm.formRules,"size":"medium","label-width":"140px"},nativeOn:{"submit":function($event){$event.preventDefault();return _vm.onSubmit()}}},[_c('div',{staticClass:"re-el-form__flex"},[_c('div',{staticClass:"medium"},[_c('el-form-item',{attrs:{"label":"客户名称:"}},[_c('el-input',{attrs:{"disabled":""},model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"客户编号:"}},[_c('el-input',{attrs:{"disabled":""},model:{value:(_vm.form.number),callback:function ($$v) {_vm.$set(_vm.form, "number", $$v)},expression:"form.number"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"relationship_type","label":"客户关系类型:"}},[_c('el-col',{attrs:{"span":_vm.inputWith}},[_c('el-select',{attrs:{"placeholder":"请选择类型","filterable":""},model:{value:(_vm.form.relationship_type),callback:function ($$v) {_vm.$set(_vm.form, "relationship_type", $$v)},expression:"form.relationship_type"}},_vm._l((_vm.options.customerRelationshipType),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}),1)],1)],1),_vm._v(" "),(_vm.form.relationship_type === '3')?_c('el-form-item',{attrs:{"prop":"mail_post_time","label":"发送时间:"}},[_c('el-date-picker',{attrs:{"value-format":"yyyy-MM-dd","type":"date","placeholder":"请选择发送时间","align":"center"},model:{value:(_vm.form.mail_post_time),callback:function ($$v) {_vm.$set(_vm.form, "mail_post_time", $$v)},expression:"form.mail_post_time"}})],1):_vm._e(),_vm._v(" "),_c('el-col',{attrs:{"span":24}},[_c('div',[_c('h3',[_vm._v("项目对接人\n                "),_c('el-button',{staticClass:"add-contact",attrs:{"type":"primary","size":"mini"},on:{"click":_vm.onAddContactor}},[_vm._v("新增\n                ")])],1)])]),_vm._v(" "),_vm._l((_vm.form.mainContactors),function(person,index){return _c('div',{staticClass:"margin b15"},[_c('span',{staticClass:"contact-title"},[_vm._v("项目对接人"+_vm._s(index+1))]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"客户联系人:"}},[_c('el-input',{model:{value:(person.name),callback:function ($$v) {_vm.$set(person, "name", $$v)},expression:"person.name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"职位:"}},[_c('el-input',{model:{value:(person.job_title),callback:function ($$v) {_vm.$set(person, "job_title", $$v)},expression:"person.job_title"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"联系方式:"}},[_c('el-input',{model:{value:(person.phone),callback:function ($$v) {_vm.$set(person, "phone", $$v)},expression:"person.phone"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"邮箱:"}},[_c('el-input',{model:{value:(person.email),callback:function ($$v) {_vm.$set(person, "email", $$v)},expression:"person.email"}})],1)],1)}),_vm._v(" "),_vm._l((_vm.form.contactors),function(contactor,index){return _c('el-row',{key:'contactor' + index},[_c('span',{staticClass:"contact-title"},[_vm._v("项目对接人"+_vm._s(index+_vm.form.mainContactors.length+1))]),_vm._v(" "),_c('el-button',{staticClass:"delete-button",attrs:{"type":"primary","icon":"el-icon-delete","size":"mini"},on:{"click":function($event){return _vm.onDelContactor(index)}}}),_vm._v(" "),_c('div',{staticClass:"contact-body"},[_c('el-form-item',{attrs:{"label":"客户联系人:"}},[_c('el-input',{model:{value:(contactor.name),callback:function ($$v) {_vm.$set(contactor, "name", $$v)},expression:"contactor.name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"职位:"}},[_c('el-input',{model:{value:(contactor.job_title),callback:function ($$v) {_vm.$set(contactor, "job_title", $$v)},expression:"contactor.job_title"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"联系方式:"}},[_c('el-input',{model:{value:(contactor.phone),callback:function ($$v) {_vm.$set(contactor, "phone", $$v)},expression:"contactor.phone"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"邮箱:"}},[_c('el-input',{model:{value:(contactor.email),callback:function ($$v) {_vm.$set(contactor, "email", $$v)},expression:"contactor.email"}})],1),_vm._v(" "),_c('el-input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],model:{value:(contactor.id),callback:function ($$v) {_vm.$set(contactor, "id", $$v)},expression:"contactor.id"}}),_vm._v(" "),_c('el-input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],model:{value:(contactor.type),callback:function ($$v) {_vm.$set(contactor, "type", $$v)},expression:"contactor.type"}})],1)],1)}),_vm._v(" "),_c('el-col',{staticClass:"contact-title",attrs:{"span":24}},[_c('h3',[_vm._v("客户采购\n              "),_c('el-button',{staticClass:"add-contact",attrs:{"type":"primary","size":"mini"},on:{"click":function($event){return _vm.onAddBuyer()}}},[_vm._v("新增\n              ")])],1)]),_vm._v(" "),_c('div',{staticClass:"margin b15"},_vm._l((_vm.form.buyers),function(buyer,index){return _c('el-row',{key:'buyer' + index},[_c('span',{staticClass:"contact-title"},[_vm._v("客户采购"+_vm._s(index+1))]),_vm._v(" "),_c('el-button',{staticClass:"delete-button",attrs:{"type":"primary","icon":"el-icon-delete","size":"mini"},on:{"click":function($event){return _vm.onDelBuyer(index)}}}),_vm._v(" "),_c('el-form-item',{attrs:{"label":"客户联系人:"}},[_c('el-input',{model:{value:(buyer.name),callback:function ($$v) {_vm.$set(buyer, "name", $$v)},expression:"buyer.name"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"联系方式:"}},[_c('el-input',{model:{value:(buyer.phone),callback:function ($$v) {_vm.$set(buyer, "phone", $$v)},expression:"buyer.phone"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"邮箱:"}},[_c('el-input',{model:{value:(buyer.email),callback:function ($$v) {_vm.$set(buyer, "email", $$v)},expression:"buyer.email"}})],1),_vm._v(" "),_c('el-input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],model:{value:(buyer.id),callback:function ($$v) {_vm.$set(buyer, "id", $$v)},expression:"buyer.id"}}),_vm._v(" "),_c('el-input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],model:{value:(buyer.type),callback:function ($$v) {_vm.$set(buyer, "type", $$v)},expression:"buyer.type"}})],1)}),1)],2)]),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary","native-type":"submit"}},[_vm._v("提交表单\n        ")]),_vm._v(" "),_c('el-button',{on:{"click":_vm.onReload}},[_vm._v("重置")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// static/js/customer-relationship-form.d6b0e380461c33c13cdb.js